module.exports = __webpack_public_path__ + "img/bg2.c886e729.jpg";